/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {GetLoginLinkResponse} from '../models/GetLoginLinkResponse';
import type {GetLoginLinksByEmailsRequest} from '../models/GetLoginLinksByEmailsRequest';
import type {GetLoginLinksByIdsRequest} from '../models/GetLoginLinksByIdsRequest';
import type {GetLoginLinksResponse} from '../models/GetLoginLinksResponse';
import type {UserLoginActionResponse} from '../models/UserLoginActionResponse';

export interface CanUseLoginLink$Request {
    userId: number;
}

export interface CanUseLoginLink$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const canUseLoginLinkRequest = createAction<PayloadData<void, CanUseLoginLink$Request>>('LOGIN_LINK_CONTROLLER__CAN_USE_LOGIN_LINK__REQUEST');
export const canUseLoginLinkSuccess = createAction<PayloadData<UserLoginActionResponse, CanUseLoginLink$Request>>('LOGIN_LINK_CONTROLLER__CAN_USE_LOGIN_LINK__SUCCESS');
export const canUseLoginLinkFailure = createAction<PayloadData<Error, CanUseLoginLink$Request, true>>('LOGIN_LINK_CONTROLLER__CAN_USE_LOGIN_LINK__FAILURE');

export const canUseLoginLinkActions = [
    canUseLoginLinkRequest,
    canUseLoginLinkSuccess,
    canUseLoginLinkFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const canUseLoginLink = (meta: CanUseLoginLink$Request, config?: CanUseLoginLink$Config) => {
    return {
        CALL_API: {
            types: canUseLoginLinkActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/can-login`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetLoginLink$Request {
    userId: number;
}

export interface GetLoginLink$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getLoginLinkRequest = createAction<PayloadData<void, GetLoginLink$Request>>('LOGIN_LINK_CONTROLLER__GET_LOGIN_LINK__REQUEST');
export const getLoginLinkSuccess = createAction<PayloadData<GetLoginLinkResponse, GetLoginLink$Request>>('LOGIN_LINK_CONTROLLER__GET_LOGIN_LINK__SUCCESS');
export const getLoginLinkFailure = createAction<PayloadData<Error, GetLoginLink$Request, true>>('LOGIN_LINK_CONTROLLER__GET_LOGIN_LINK__FAILURE');

export const getLoginLinkActions = [
    getLoginLinkRequest,
    getLoginLinkSuccess,
    getLoginLinkFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getLoginLink = (meta: GetLoginLink$Request, config?: GetLoginLink$Config) => {
    return {
        CALL_API: {
            types: getLoginLinkActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/generate-login-link`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetLoginLinksByEmails$Request {
    getLoginLinksByEmailsRequest: GetLoginLinksByEmailsRequest;
}

export interface GetLoginLinksByEmails$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getLoginLinksByEmailsRequest = createAction<PayloadData<void, GetLoginLinksByEmails$Request>>('LOGIN_LINK_CONTROLLER__GET_LOGIN_LINKS_BY_EMAILS__REQUEST');
export const getLoginLinksByEmailsSuccess = createAction<PayloadData<Array<GetLoginLinksResponse>, GetLoginLinksByEmails$Request>>('LOGIN_LINK_CONTROLLER__GET_LOGIN_LINKS_BY_EMAILS__SUCCESS');
export const getLoginLinksByEmailsFailure = createAction<PayloadData<Error, GetLoginLinksByEmails$Request, true>>('LOGIN_LINK_CONTROLLER__GET_LOGIN_LINKS_BY_EMAILS__FAILURE');

export const getLoginLinksByEmailsActions = [
    getLoginLinksByEmailsRequest,
    getLoginLinksByEmailsSuccess,
    getLoginLinksByEmailsFailure
] as const;

/**
 * @param {GetLoginLinksByEmailsRequest} meta.getLoginLinksByEmailsRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getLoginLinksByEmails = (meta: GetLoginLinksByEmails$Request, config?: GetLoginLinksByEmails$Config) => {
    return {
        CALL_API: {
            types: getLoginLinksByEmailsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/generate-login-link-by-email`,
            TRANSPORT_REQUEST_BODY: meta.getLoginLinksByEmailsRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetLoginLinksByIds$Request {
    getLoginLinksByIdsRequest: GetLoginLinksByIdsRequest;
}

export interface GetLoginLinksByIds$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getLoginLinksByIdsRequest = createAction<PayloadData<void, GetLoginLinksByIds$Request>>('LOGIN_LINK_CONTROLLER__GET_LOGIN_LINKS_BY_IDS__REQUEST');
export const getLoginLinksByIdsSuccess = createAction<PayloadData<Array<GetLoginLinksResponse>, GetLoginLinksByIds$Request>>('LOGIN_LINK_CONTROLLER__GET_LOGIN_LINKS_BY_IDS__SUCCESS');
export const getLoginLinksByIdsFailure = createAction<PayloadData<Error, GetLoginLinksByIds$Request, true>>('LOGIN_LINK_CONTROLLER__GET_LOGIN_LINKS_BY_IDS__FAILURE');

export const getLoginLinksByIdsActions = [
    getLoginLinksByIdsRequest,
    getLoginLinksByIdsSuccess,
    getLoginLinksByIdsFailure
] as const;

/**
 * @param {GetLoginLinksByIdsRequest} meta.getLoginLinksByIdsRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getLoginLinksByIds = (meta: GetLoginLinksByIds$Request, config?: GetLoginLinksByIds$Config) => {
    return {
        CALL_API: {
            types: getLoginLinksByIdsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/generate-login-link-by-id`,
            TRANSPORT_REQUEST_BODY: meta.getLoginLinksByIdsRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

